export default [{
  name: 'For Business',
  href: 'https://about.paddl.com'
}, {
  name: 'Pricing',
  href: 'https://about.paddl.com/pricing'
}, {
  name: 'Blog',
  href: 'https://about.paddl.com/blog'
}];